import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appNumbersOnly]',
    standalone: false
})
export class NumbersOnlyDirective {
	constructor(
		private el: ElementRef,
		private ngControl: NgControl
	) {}

	@HostListener('input', ['$event']) onInputChange(event: any) {
		const inputValue: string = event.target.value;
		// Remove tudo exceto números
		const newValue: string = inputValue.replace(/\D/g, '');

		// Atualiza o valor no elemento nativo e no NgControl
		this.el.nativeElement.value = newValue;
		this.ngControl?.control?.setValue(newValue);
	}
}
